<template>
  <div class="queue-location-list ps__child--consume">
    <LocationListItem
      v-if="!hasSearch"
      is-switch-all
      :location="switchAllLocation"
      @change="
        $emit('change', {
          shouldEnableAll: true,
          location: switchAllLocation
        })
      "
    />
    <LocationListItem
      v-for="location in locations"
      :key="location.id"
      :location="location"
      @change="
        $emit('change', {
          shouldEnableAll: false,
          location
        })
      "
    />

    <!-- INFINITE LOADER -->
    <div
      v-if="hasMorePages && !isLoading && !isLoadingMore"
      ref="targetRef"
      class="text-center py-3"
    >
      <small class="text-muted">Scroll for more...</small>
    </div>

    <!-- LOADING MORE INDICATOR -->
    <div
      v-if="isLoadingMore"
      class="justify-content-center align-content-center rounded-30 my-3 d-flex gap-2"
    >
      <CSpinner color="primary" size="sm" />
    </div>
  </div>
</template>

<script>
import useIntersectionObserver from "@/composables/useIntersectionObserver"
import LocationListItem from "@/v3components/Queue/QueueLocation/LocationListItem.vue"
import { computed } from "vue"

export default {
  name: "LocationList",
  components: {
    LocationListItem
  },
  props: {
    hasSearch: {
      type: Boolean,
      default: false
    },
    areAllLocationQueueable: {
      type: Boolean,
      default: false
    },
    locations: {
      type: Array,
      default: () => []
    },
    hasMorePages: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isLoadingMore: {
      type: Boolean,
      default: false
    }
  },
  emits: ["change", "loadMore"],
  setup(props, { emit }) {
    const switchAllLocation = computed(() => ({
      id: "switch-all",
      name: props.areAllLocationQueueable ? "Switch off all" : "Switch on all",
      is_queueable: props.areAllLocationQueueable
    }))

    const { targetRef } = useIntersectionObserver({
      onIntersect: () => emit("loadMore"),
      observerOptions: {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
      }
    })

    return {
      switchAllLocation,
      targetRef
    }
  }
}
</script>

<style scoped>
.queue-location-list {
  max-height: 600px;
  overflow-y: auto;
}
</style>
